import { all, takeLatest, call, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { organisation as organisationService } from 'services';
import {
  fetchUserOrganisationSuccess,
  fetchUserOrganisationFailure
} from './actions';
import { OrganisationActionTypes } from './types';

export function* handleFetchUserOrganisation() {
  try {
    const response: AxiosResponse = yield call(
      organisationService.getOrganisation
    );
    if (response?.data) {
      yield put(fetchUserOrganisationSuccess(response.data));
    } else {
      yield put(
        fetchUserOrganisationFailure('Unable to fetch user organisation')
      );
    }
  } catch (error) {
    yield put(
      fetchUserOrganisationFailure('Unable to fetch user organisation')
    );
  }
}

export function* onFetchUserOrganisation() {
  yield takeLatest(
    OrganisationActionTypes.FETCH_USER_ORGANISATION_START,
    handleFetchUserOrganisation
  );
}

export function* organisationSagas() {
  yield all([call(onFetchUserOrganisation)]);
}

export default organisationSagas;
